<div class="action">
    <input [formControl]="dynamicNormForm.controls[data.id]" placeholder="Enter Custom Norm Value" />
    <button class="btn btn-primary" (click)="action('update', data.id)">
        Update
    </button>
</div>